import {
  firebase,
  db,
  auth
} from '@/fb';


export function titleCase(str) {
  str = str.toLowerCase().split(' ');
  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
  }
  return str.join(' ');
}

export function randomString(length, chars) {
  var mask = '';
  if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
  if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (chars.indexOf('#') > -1) mask += '0123456789';
  var result = '';
  for (var i = length; i > 0; --i) result += mask[Math.floor(Math.random() * mask.length)];
  return result;
}

export function uuid() {
  let uuid = randomString(16, 'aA#')
  return uuid
}

export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function launchFullScreen(element) {
  if (element.requestFullScreen) {
    element.requestFullScreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen();
  }
}

export function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

export function getCDate() {
  return new Date().toISOString()
}

export function readableDate(date) {
  return new Date(date).toISOString()
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function check(l) {
  //////////////////
  let lead = l
  let cfdC = ['United Arab Emirates', 'Qatar']
  let clickTradeC = ['Oman', 'Kuwait', 'Bahrain', 'Saudi Arabia']
  let cfd = {
    name: 'cfd',
    type: 'post',
    hook: 'https://leadapi-b2b.extsrv.com/crm-public-api/2.0.0/lead',
    url: 'http://api.4w7pc5z8gc.com',
    access_token: '52sO03ucptBQkHlGLmWtfW31gjEa',
    pid: '35565',
    content_type: 'application/x-www-form-urlencoded',
    crm_brand_id: '68'
  }
  let clickTrade = {
    name: 'clickTrade',
    type: 'post',
    hook: 'https://leadapi-b2b.extsrv.com/crm-public-api/2.0.0/lead',
    url: 'http://api.4w7pc5z8gc.com',
    access_token: '52sO03ucptBQkHlGLmWtfW31gjEa',
    pid: '35566',
    content_type: 'application/x-www-form-urlencoded',
    crm_brand_id: '84'
  }
  let umarkets = {
    linkid: 'HighEnd',
    name: 'umarkets',
    url: function () {
      return `https://api.umarkets.com/Registration/Lead?Email=${this.email}&PhoneCountry=${this.countrycode}&PhoneOperator=${this.areacode}&PhoneNumber=${this.basephone}&FirstName=${this.name}&LastName=${this.name}&linkid=${this.linkid}&UtmCampaign=${this.utm_campaign}&UtmSource=${this.utm_source}&UtmContent=${this.utm_content}`
    }
  }

  if (!lead.email) {
    lead.email = `g_${randomString(2, '#')}_name${randomString(4, '#')}@gmail.com`
    if (!lead.country) {
      let n = lead.phone;
      let g = parseInt(n).toString().slice(0, 3);
      db.ref('countries/')
        .once('value')
        .then(x => {
          let c = x.val()
          let d = c.filter(x => x.callingCodes[0] == g);
          let country
          let brand
          if (d.length == 0) {
            g = parseInt(n).toString().slice(0, 2);
            d = c.filter(x => x.callingCodes[0] == g);
            if (d.length != 0) {
              console.log(d[0].name)
              country = d[0].name
            } else {
              // console.log('non found')
            }
          } else {
            if (d.length != 0) {
              console.log(d[0].name)
              country = d[0].name
            } else {
              // console.log('non found')
            }
          }

          function frmatPhone(phone) {
            let n = phone;
            let g = parseInt(n).toString().slice(0, 3);
            let d = c.filter(x => x.callingCodes[0] == g);
            if (d.length != 0) {
              lead.countrycode = g
              lead.areacode = parseInt(n).toString().slice(3, 5);
              lead.basephone = parseInt(n).toString().slice(5);
            } else {
              g = parseInt(n).toString().slice(0, 2);
              d = c.filter(x => x.callingCodes[0] == g);
              if (d.length != 0) {
                lead.countrycode = g
                lead.areacode = parseInt(n).toString().slice(2, 4);
                lead.basephone = parseInt(n).toString().slice(4);
              } else {
                lead.countrycode = false
              }
            }
          }
          lead.country = country
          frmatPhone(lead.phone)
          if (cfdC.indexOf(country) != -1) {
            lead.brand = 'cfd'
            lead = Object.assign(lead, {
              brand: cfd
            })
          } else if (clickTradeC.indexOf(country) != -1) {
            lead.brand = 'clicktrade'
            lead = Object.assign(lead, {
              brand: clickTrade
            })
          } else {
            lead.brand = 'umarkets'
            Object.assign(umarkets, lead)
            let brand = Object.assign({
              url: umarkets.url(),
              name: 'umarkets'
            }, lead)
            lead = Object.assign(lead, {
              brand
            })
          }
          console.log({
            lead
          })
        })
    }
  } else if (!lead.country) {
    let n = lead.phone;
    let g = parseInt(n).toString().slice(0, 3);
    db.ref('countries/')
      .once('value')
      .then(x => {
        let c = x.val()
        let d = c.filter(x => x.callingCodes[0] == g)
        let country
        let brand
        if (d.length == 0) {
          g = parseInt(n).toString().slice(0, 2)
          d = c.filter(x => x.callingCodes[0] == g)
          if (d.length != 0) {
            console.log(d[0].name)
            console.log(d[0].callingCodes[0])
            country = d[0].name
          } else {
            country = false
          }
        } else {
          if (d.length != 0) {
            console.log(d[0].name)
            console.log(d[0].callingCodes[0])
            country = d[0].name
          } else {
            country = false
          }
        }

        function frmatPhone(phone) {
          let n = phone;
          let g = parseInt(n).toString().slice(0, 3);
          let d = c.filter(x => x.callingCodes[0] == g);
          if (d.length != 0) {
            lead.countrycode = g
            lead.areacode = parseInt(n).toString().slice(3, 5);
            lead.basephone = parseInt(n).toString().slice(5);
          } else {
            g = parseInt(n).toString().slice(0, 2);
            d = c.filter(x => x.callingCodes[0] == g);
            if (d.length != 0) {
              lead.countrycode = g
              lead.areacode = parseInt(n).toString().slice(2, 4);
              lead.basephone = parseInt(n).toString().slice(4);
            } else {
              lead.countrycode = false
            }
          }
        }
        lead.country = country
        frmatPhone(lead.phone)
        if (cfdC.indexOf(country) != -1) {
          lead.brand = 'cfd'
          lead = Object.assign(lead, {
            brand: cfd
          })
        } else if (clickTradeC.indexOf(country) != -1) {
          lead.brand = 'clicktrade'
          lead = Object.assign(lead, {
            brand: clickTrade
          })
        } else {
          lead.brand = 'umarkets'
          Object.assign(umarkets, lead)
          let brand = Object.assign({
            url: umarkets.url(),
            name: 'umarkets'
          }, lead)
          lead = Object.assign(lead, {
            brand
          })
        }
        console.log({
          lead
        })
      })
  } else {
    let n = lead.phone;
    let g = parseInt(n).toString().slice(0, 3);
    db.ref('countries/')
      .once('value')
      .then(x => {
        let c = x.val()
        let d = c.filter(x => x.callingCodes[0] == g)
        let country
        let brand
        if (d.length == 0) {
          g = parseInt(n).toString().slice(0, 2)
          d = c.filter(x => x.callingCodes[0] == g)
          if (d.length != 0) {
            console.log(d[0].name)
            console.log(d[0].callingCodes[0])
            country = d[0].name
          } else {
            country = false
          }
        } else {
          if (d.length != 0) {
            console.log(d[0].name)
            console.log(d[0].callingCodes[0])
            country = d[0].name
          } else {
            country = false
          }
        }

        function frmatPhone(phone) {
          let n = phone;
          let g = parseInt(n).toString().slice(0, 3);
          let d = c.filter(x => x.callingCodes[0] == g);
          if (d.length != 0) {
            lead.countrycode = g
            lead.areacode = parseInt(n).toString().slice(3, 5);
            lead.basephone = parseInt(n).toString().slice(5);
          } else {
            g = parseInt(n).toString().slice(0, 2);
            d = c.filter(x => x.callingCodes[0] == g);
            if (d.length != 0) {
              lead.countrycode = g
              lead.areacode = parseInt(n).toString().slice(2, 4);
              lead.basephone = parseInt(n).toString().slice(4);
            } else {
              lead.countrycode = false
            }
          }
        }
        frmatPhone(lead.phone)
        if (cfdC.indexOf(lead.country) != -1) {
          lead.brand = 'cfd'
          lead = Object.assign(lead, {
            brand: cfd
          })
        } else if (clickTradeC.indexOf(lead.country) != -1) {
          lead.brand = 'clicktrade'
          lead = Object.assign(lead, {
            brand: clickTrade
          })
        } else {
          lead.brand = 'umarkets'
          Object.assign(umarkets, lead)
          let brand = Object.assign({
            url: umarkets.url(),
            name: 'umarkets'
          }, lead)
          lead = Object.assign(lead, {
            brand
          })
        }
        console.log({
          lead
        })
      })
  }

  //////////////////
}